export default __webpack_public_path__ + "static/media/blog04.6acdec9a.png";